
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 28.619l-8.099 3.446c-1.39.592-2.908-.512-2.775-2.016l.775-8.767-5.78-6.638C.127 13.505.708 11.72 2.18 11.38l8.577-1.972 4.527-7.549c.776-1.295 2.654-1.295 3.43 0l4.527 7.549 8.578 1.972c1.471.339 2.051 2.124 1.06 3.263l-5.78 6.638.774 8.767c.133 1.504-1.385 2.608-2.775 2.016L17 28.62z","fill":"#F90"}})])
          )
        }
      }
    